/**
 * @file
 * Custom tile layer.
 */

/**
 * @typedef {Object} CustomTileLayerSettings
 *
 * @extends {GeolocationMapFeatureSettings}
 *
 * @property {String} tileLayerUrl
 * @property {String} tileLayerAttribution
 * @property {String} tileLayerSubdomains
 * @property {Number} tileLayerZoom
 */

(function (Drupal) {

  'use strict';

  /**
   * Custom Tile Layer.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *   Attaches Custom Tile Layer functionality to relevant elements.
   */
  Drupal.behaviors.leafletCustomTileLayer = {
    attach: function (context, drupalSettings) {
      Drupal.geolocation.executeFeatureOnAllMaps(
        'leaflet_custom_tile_layer',

        /**
         * @param {GeolocationLeafletMap} map - Current map.
         * @param {CustomTileLayerSettings} featureSettings - Settings for current feature.
         */
        function (map, featureSettings) {
          map.tileLayer.remove();
          map.tileLayer = L.tileLayer('https://api.mapbox.com/styles/v1/fschaff/cl4iedh4g002f15pjx8pllrvl/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZnNjaGFmZiIsImEiOiJjaWxyc3BzZGowMDdndWlsdWQ0dWZ4NGM3In0.rCgfZ7vxak80XFuZABaqNQ', {
            tileSize: 512,
            zoomOffset: -1,
            attribution: '© fschaff'
          }).addTo(map.leafletMap);

          return true;
        },
        drupalSettings
      );
    },
    detach: function (context, drupalSettings) {}
  };
})(Drupal);
